import { Component } from '@angular/core';
import {ICellRendererAngularComp} from "ag-grid-angular";
import {ICellRendererParams} from "ag-grid-community";
import {ConfirmModalConfig} from "@app/interfaces/common-modal-popups";
import {TranslateService} from "@ngx-translate/core";


interface ICustomStatusType{
    status: boolean;
    disabled: boolean;
    onChangeCallback?: Function;

}
type ICellRendererParamsWithGridType = ICellRendererParams & ICustomStatusType;

@Component({
    selector: 'app-switch-renderer',
    templateUrl: './switch-renderer.component.html',
    styles: ['' +
    '.btn-actions .btn {padding: 0}' +
    '']
})
export class SwitchRendererComponent implements ICellRendererAngularComp {
    disabled: boolean = false;
    public params: ICellRendererParamsWithGridType;
    statusActivationConfirmation: ConfirmModalConfig;

    constructor(
        private _translate: TranslateService
    ) {
    }
    agInit(params: ICellRendererParamsWithGridType): void {
        this.params = params;
        this.disabled = this.params.disabled;
        let { dagSource } = this.params.data;
        if(!this.params.disabled) {
            if(!dagSource) {
                dagSource = [];
            }
            else {
                const $_dagSource = JSON.parse(dagSource);
                dagSource = $_dagSource['endBlocks'];
            }
            this.params.disabled = dagSource.length == 0;
        }
        this.params.status = this.params.data.status != 0;
        this.statusActivationConfirmation = {
            modalType: 'confirm',
            actionText: 'ACTIVATE',
            confirmBtnType: 'DEFAULT',
            confirmBtnText: "ACTIVATE",
            confirmBxValidationMsg: '',
            itemText: "Automation",
            showModal: false,
            closeText: 'Close',
            message: {
                warningTxt: this._translate.instant('Automation.Confirm.Status.Activation.Message', {
                    automationName: this.params.data['name']
                }),
                helpTxtList: ['Automation.Activate.Now.Or.Save.As.Draft']
            },
            title: 'Confirm.Activation',
            doAction: this.onChangeCallback.bind(this),
            actionArg: '',
        }
    }

    refresh(params: any): boolean {
        return true;
    }

    onChangeCallback(currentStatus, cb) {
        if(this.params.onChangeCallback) {
            this.params.onChangeCallback(currentStatus, cb, this);
        }
    }

    onChangeStatusConfirmation() {
        const message = {};
        if(this.params.status) {
            message['warningTxt'] =  this._translate.instant('Automation.Confirm.Status.Activation.Message', {
                automationName: this.params.data['name']
            });
            message['helpTxtList'] = [];
        }
        else {
            message['warningTxt'] =  this._translate.instant('Automation.Confirm.Status.Deactivation.Message', {
                automationName: this.params.data['name']
            });
            message['helpTxtList'] = ['Custom.Automation.Deactivate.Message'];
        }
        const confirmBxValidationMsg = this.params.status ? this._translate.instant('confirmation.warning.text', { word: 'ACTIVATE', message: 'activate the automation'}) :
            this._translate.instant('confirmation.warning.text', { word: 'DEACTIVATE', message: 'deactivate the automation'});
        this.statusActivationConfirmation.actionArg = this.params.status;
        this.statusActivationConfirmation.confirmBxValidationMsg = confirmBxValidationMsg;
        this.statusActivationConfirmation.message = message;
        this.statusActivationConfirmation.showModal=true;
        this.statusActivationConfirmation.confirmBtnText = this.params.status ? "ACTIVATE" : "DEACTIVATE";
        this.statusActivationConfirmation.title = this.params.status ? 'Confirm.Activation' : 'Confirm.Deactivation';
        this.statusActivationConfirmation.actionText = this.params.status ? 'ACTIVATE' : 'DEACTIVATE';
    }

    onCloseConfirmation(isCloseBtn:string, type:string) {
        if(type == 'activate') {
            if(isCloseBtn == 'CANCEL_BTN' || isCloseBtn == 'CLOSE_ICON')
                this.params.status = !this.params.status;
            this.statusActivationConfirmation.showModal=false;
        }
    }

}
